import React, { Component } from "react";
import "./styles/Home.css";
import HomeSlider from "../components/HomeSlider";
import HomeKindCommerce from "../components/HomeKindCommerce";
import MarketStoreBanner from "../components/MarketStoreBanner";
import HowToWork from "../components/HowToWork";
import Footer from "../components/Footer";
import Modal from "../components/Modal";
import DonwloadApp from "../components/DownloadApp";
import BlogCarousel from "../components/BlogCarousel";
import AboutGodiway from "../components/AboutGodiway";

class HomeOut extends Component {
  render() {
    return (
      <React.Fragment>
        <HomeSlider />
        <div className="">
          <div className="">
            <div className=" ">
              <HomeKindCommerce />
              <AboutGodiway />
            </div>
          </div>
          <HowToWork />
          <MarketStoreBanner />
          <BlogCarousel />
        </div>
        <DonwloadApp />
        <Footer />
        <Modal isOpen={false} />
      </React.Fragment>
    );
  }
}

export default HomeOut;
